import {
  CLEAR_RESPONSE,
  RESPONSE_REQUEST,
  RESPONSE_FAILURE,
  RESPONSE_SUCCESS,
  TOGGLE_OBSERVERS_VIEW_PII
} from '../actions/responseActions'

const initialState = {
  loading: false,
  responses: {}
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RESPONSE_REQUEST:
      return {
        ...state,
        loading: true,
        errors: null
      }
    case RESPONSE_SUCCESS:
      return {
        ...state,
        loading: false,
        responses: {
          [action.data.id]: action.data
        }
      }
    case RESPONSE_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.errors
      }
    case CLEAR_RESPONSE: {
      const { responses } = state
      // eslint-disable-next-line no-unused-vars
      const { [action.id.toString()]: removedResponse, ...rest } = responses

      return {
        ...state,
        responses: rest
      }
    }
    case TOGGLE_OBSERVERS_VIEW_PII: {
      const { responses } = state
      const { [action.id]: response, ...rest } = responses

      return {
        ...state,
        responses: {
          ...rest,
          [action.id]: {
            ...response,
            observersViewPiiFl: action.value
          }
        }
      }
    }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ../src/reducers/responses.js